import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { formatDateTime } from '../utils/formatDate';
import Pagination from '../components/Pagination';
import Loader from "../components/Loader"
import { PiDotsThree } from 'react-icons/pi';
import Spinner from '../components/Spinner';

const Collections = () => {
  const [collectionData, setCollectionData] = useState({
    collection_name: '',     
    description: '',            
    shipment_id: '',  
    delivered: false,        
    packages: 0,             
    tag_id: '',            
    weight: 0,       

  });
  

  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: 0,
  });

  const [showMore, setShowMore] = useState(false);

  const [collections, setCollection] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const  [currentPage, setCurrentPage] = useState(1);
  const [currentCollectionId, setCurrentCollectionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  const fetchCollection = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/api/collections`);
      if (!response.ok) {
        throw new Error('Failed to fetch collections');
      }
      const data = await response.json();
      setCollection(data['collections']);
      setMetaData(data['meta'])
      console.log(data)
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchCollection();
    setLoading(false);
  }, []);

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      if (editMode) {
        await fetch(`${apiUrl}/api/collections/${currentCollectionId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(collectionData),
        });
      } else {
        await fetch(`${apiUrl}/api/collections`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(collectionData),
        });
      }
      fetchCollection();
      handleModalClose();
      console.log(`Data sent ${collectionData.tracking_number}`)
    } catch (error) {
      console.error('Error saving collection:', error);
      setError('Error saving collection. Please try again.');
    } finally {
    setLoading(false);

    }
  };

  const handleEdit = (id) => {
    const collectionToEdit = collections.find((pkg) => pkg.id === id);
    if (collectionToEdit) {
      setCollectionData(collectionToEdit);
      setCurrentCollectionId(id);
      setEditMode(true);
      setModalOpen(true);
    }
  };

  const handleDeleteModal = (id) => {
    const collectionToDelete = collections.find((pkg) => pkg.id === id);
    if (collectionToDelete) {
      setCollectionData(collectionToDelete);
      setCurrentCollectionId(id);
      setModalDeleteOpen(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${apiUrl}/api/collections/${id}`, {
        method: 'DELETE',
      });
      fetchCollection();
      setModalDeleteOpen(false);
    } catch (error) {
      console.error('Error deleting collection:', error);
      setError('Error deleting collection. Please try again.');
      setModalDeleteOpen(false);

    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEditMode(false);
    setCurrentCollectionId(null);
    setCollectionData({
      collection_name: '',     
      description: '',            
      shipment_id: '',  
      delivered: false,        
      packages: 0,             
      tag_id: '',            
      weight: 0,   
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCollectionData({ ...collectionData, [name]: value });
  };



  return (
    <Layout>
       {loading ? <Spinner/> : <main className='p-4 bg-base-100 shadow-xl w-4/5 lg:w-full h-[100%] '>
      <section className="flex justify-between items-center mb-4">
          <h2 className="text-3xl font-semibold">Collections</h2> 
          {/* Pagination */}
     
          <button className="btn btn-error text-white" onClick={() => setModalOpen(true)}>
            Add Collection
          </button>
        </section>
        <section className='mb-4'>

  <table className="table-auto w-full border-collapse border border-gray-300">
    <thead className="border border-gray-300 bg-base-200">
      <tr>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Collection</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Description</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Shipment</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Packages</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Tag</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Weight</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Created</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Last Updated</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Delivered</th>
        <th className="border px-2 sm:px-4 py-2 text-left font-semibold">Action</th>

      </tr>
    </thead>
    <tbody>
      {collections.map((shpmt) => (
        <tr className="md:table-row block md:border-none border border-gray-300">
          <td className="md:border border-gray-300 px-4 py-2" data-label="Collection Number">{shpmt.collection_name}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Carrier">{shpmt.description}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Origin">{shpmt.shipment_id}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Destination">{shpmt.packages}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Departs On">{shpmt.tag_id}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Arrives On">{shpmt.weight}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Auto Update Status">{formatDateTime(shpmt.created_at)}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Manifest Weight">{formatDateTime(shpmt.updated_at)}</td>
          <td className="md:border border-gray-300 px-4 py-2" data-label="Freight Type">{shpmt.delivered ? "Yes" : "No"}</td>
          <td className="border px-2 sm:px-4 py-2">
                  <div className="dropdown">
                    <div tabIndex={0} role="button" className="btn m-1 bg-base-300">
                      <PiDotsThree />
                    </div>
                    <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                      <li onClick={() => handleEdit(shpmt.id)}><a>Edit</a></li>
                      <li onClick={() => handleDeleteModal(shpmt.id)} className="text-red-500"><a>Delete</a></li>
                    </ul>
                  </div>
                </td>
        </tr>
      ))}
    </tbody>
  </table>


        </section>
        {/* <Pagination 
        currentPage={metaData.currentPage}
        totalPages={metaData.totalPages}   
        onPageChange={(page) => setCurrentPage(page)}
        /> */}
      </main>
}
      {modalOpen && (
     <dialog className="modal modal-open bg-gray-50 ">
     <form onSubmit={handleSubmit} className="modal-box space-y-4">
       <h1 className="text-3xl text-center mb-6">Add Collection</h1>
   
       <div className="flex gap-4">
         <div className="form-control">
           <label htmlFor="collection_name" className="label">
             <span className="label-text">Collection Name</span>
           </label>
           <input
             type="text"
             id="collection_name"
             name="collection_name"
             value={collectionData.collection_name}
             onChange={handleInputChange}
             className="input input-bordered w-full"
             required
           />
         </div>
       </div>
   
       <div className="flex gap-4">
         <div className="form-control">
           <label htmlFor="description" className="label">
             <span className="label-text">Description</span>
           </label>
           <input
             type="text"
             id="description"
             name="description"
             value={collectionData.description}
             onChange={handleInputChange}
             className="input input-bordered w-full"
           />
         </div>
   
         {/* <div className="form-control">
           <label htmlFor="shipment_id" className="label">
             <span className="label-text">Shipment</span>
           </label>
           <select
             id="shipment_id"
             name="shipment_id"
             value={collectionData.shipment_id}
             onChange={handleInputChange}
             className="select select-bordered w-full"
           >
             <option value="">Select Shipment</option>
             {shipments.map((shipment) => (
               <option key={shipment.id} value={shipment.id}>
                 {shipment.name}
               </option>
             ))}
           </select>
         </div> */}
       </div>
   
       <div className="flex gap-4">
         <div className="form-control">
           <label htmlFor="delivered" className="label">
             <span className="label-text">Delivered</span>
           </label>
           <select
             id="delivered"
             name="delivered"
             value={collectionData.delivered}
             onChange={handleInputChange}
             className="select select-bordered w-full"
           >
             <option value="true">Yes</option>
             <option value="false">No</option>
           </select>
         </div>
   
         <div className="form-control">
           <label htmlFor="packages" className="label">
             <span className="label-text">Packages</span>
           </label>
           <input
             type="number"
             id="packages"
             name="packages"
             value={collectionData.packages}
             onChange={handleInputChange}
             className="input input-bordered w-full"
           />
         </div>
       </div>
   
       {/* <div className="form-control">
         <label htmlFor="tag_id" className="label">
           <span className="label-text">Tag</span>
         </label>
         <select
           id="tag_id"
           name="tag_id"
           value={collectionData.tag_id}
           onChange={handleInputChange}
           className="select select-bordered w-full"
         >
           <option value="">Select Tag</option>
           {tags.map((tag) => (
             <option key={tag.id} value={tag.id}>
               {tag.name}
             </option>
           ))}
         </select>
       </div> */}
   
       <div className="form-control">
         <label htmlFor="weight" className="label">
           <span className="label-text">Weight (kg)</span>
         </label>
         <input
           type="number"
           id="weight"
           name="weight"
           value={collectionData.weight}
           onChange={handleInputChange}
           className="input input-bordered w-full"
           step="0.01" // Allows decimal values for weight
         />
       </div>
   
       <div className="flex gap-4 justify-center">
         <button type="button" className="btn btn-secondary" onClick={handleModalClose}>
           Cancel
         </button>
         <button type="submit" className="btn btn-primary" disabled={loading}>
           {loading ? "Saving..." : "Save Collection"}
         </button>
       </div>
     </form>
   </dialog>
   
           )}
   
   {modalDeleteOpen && (
     <dialog id="delete_modal" className="modal modal-open">
     <div className="modal-box">
       <h3 className="text-lg font-bold">Delete {collectionData.collection_name}</h3>
       <p className="py-4">Are you Sure you want to delete {collectionData.collection_name}?</p>
   
       <div className='flex space-x-4 '>
       <button className='btn bg-error text-white' onClick={() => handleDelete(collectionData.id)} disabled={loading}>{loading ? "Deleting...": "Delete"}</button>
       <button className='btn' onClick={() => 
         setModalDeleteOpen(false)
       }>Close</button>
       </div>
     </div>
     <form method="dialog" className="modal-backdrop">
     
     </form>
   </dialog>)}
    </Layout>
  );
};

export default Collections;
